import baseAPI from '@/api';
import { GameIDType } from '@/enums/gameId';
import { GameConfigInputDto } from '@/services/dto/games/game-config-input.dto';
import { GameConfigOutputDto } from '@/services/dto/games/game-config-output.dto';
import { QueryFunctionContext } from '@tanstack/react-query';
import { UseGameConfigQueryKey } from './props';

export async function fetchGameConfig<T extends GameIDType>({
  queryKey,
}: QueryFunctionContext<UseGameConfigQueryKey<T>>): Promise<
  GameConfigOutputDto<T>
> {
  try {
    const { difficultyId, gameId, side }: GameConfigInputDto<T> = queryKey[1];

    const response = await baseAPI.get<GameConfigOutputDto<T>>(
      '/games/config',
      {
        params: {
          difficultyId,
          gameId,
          side,
        },
      },
    );

    return response.data;
  } catch (error) {
    return undefined;
  }
}
